module.exports = Em.Object.extend({
    // You can pass any data to the details prop and get it in the event listener
    dispatchEvent: function(eventName, detail) {
        var event = new Event(eventName)
        event.detail = detail
        window.dispatchEvent(event)
    }
})
